import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ProductCard = ({ title, image, description, link }) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <motion.div
      className={`relative bg-[#0F172A] border border-white/20 backdrop-blur-md shadow-lg rounded-2xl p-5 transition-transform duration-500 ease-in-out cursor-pointer hover:scale-105`}
      whileHover={{ rotateY: 5 }}
      transition={{ type: 'spring', stiffness: 120 }}
      onClick={() => setShowMore(!showMore)}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => (e.key === 'Enter' ||  e.key === ' ') && setShowMore(!showMore) }
    >
      <img
        src={image}
        alt={title}
        className="w-full h-40 rounded-xl mb-4  object-contain bg-[transparent] flex items-center justify-center"
      />
      <h3 className="text-xl font-semibold text-white mb-2">{title}</h3>

      {showMore && (
        <motion.div
          className="text-white text-sm mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          {description}
        </motion.div>
      )}

      {showMore && (
        <motion.a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-4 py-2 mt-2 bg-gradient-to-r from-purple-500 to-cyan-400 text-white rounded-full font-medium text-sm hover:scale-105 transition"
          initial={{ opacity: 0 }}
          aria-label={`Learn more about ${title}`}
          animate={{ opacity: 1 }}
        >
          Know More
        </motion.a>
      )}
    </motion.div>
  );
};

export default ProductCard;
